import { Component, OnInit } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { MatDialog } from '@angular/material';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { startWith } from 'rxjs/operators/startWith';
import { map } from 'rxjs/operators/map';
import { Folderdata } from '~admin/model/folderdata';
import { Reportdata } from '~admin/model/reportdata';
import { SelectedReport } from '~admin/model/SelectedReport';
import { Environments } from '~admin/model/environments';
import { AdminService } from '~admin/services/admin.service';
import { AppUtil } from '~util/app.util';
import { Constants } from '~util/app.constant';
import { ActionDialogComponent } from '~admin/action-dialog/action-dialog.component';

@Component({
  selector: 'app-newrequest',
  templateUrl: './newrequest.component.html',
  styleUrls: ['./newrequest.component.css']
})
export class NewrequestComponent implements OnInit {

  gridOptionsSrc: GridOptions;
  columnDefsSrc: any[];
  rowDataSrc: Folderdata[];
  gridOptionsTarg: GridOptions;
  columnDefsTarg: any[];
  rowDataTarg: Folderdata[];

  style: {};
  srcReportData: Reportdata;
  selectedReports: SelectedReport[] = [];
  SrcRowSelected = [];
  TargFolderSelected = [];
  rowSelection;
  myfolderCtrl: FormControl;
  myfolderCtrlTarget: FormControl;
  envNames: Environments[];
  selectedValueSrc = '-1';
  selectedValueTarg = '-1';
  folderDataSrc: Folderdata[];
  folderDataSrcMain: Folderdata[];
  folderDatat: Folderdata;
  folderDataTarg: Folderdata[];
  folderDataTargMain: Folderdata[];
  allMyFolders: Folderdata[];
  allMyFoldersTarget: Folderdata[];
  listOfUsers = [];
  listOfUsersTarget = [];
  allUsers = [];
  iscopyEnabled = false;
  isClearEnabled = false;
  selectedValue = null;

  filteredMyFolders: Observable<String[]>;
  filteredAllMyFolders: Observable<Folderdata[]>;
  filteredMyFoldersTarget: Observable<String[]>;

  constructor(private service: AdminService, private util: AppUtil, private dialog: MatDialog) {
    this.myfolderCtrl = new FormControl();
    this.myfolderCtrlTarget = new FormControl();
    this.gridOptionsSrc = util.getGridOptions('No data to show');
    this.gridOptionsSrc.getNodeChildDetails = this.getNodeChildDetails;
    this.columnDefsSrc = this.getColumnDefSrc();
    this.gridOptionsTarg = util.getGridOptions('No data to show');
    this.gridOptionsTarg.getNodeChildDetails = this.getNodeChildDetails;

    this.rowSelection = 'multiple';
    this.columnDefsTarg = this.getColumnDefTarg();
    this.style = Constants.gridStyle;
    this.rowDataSrc = [];
    this.rowDataTarg = [];
    this.service.getEnvironments().subscribe((data: Environments[]) => {
      this.envNames = data;
    });
    this.allMyFolders = new Array<Folderdata>();
    this.allMyFoldersTarget = new Array<Folderdata>();
    this.listOfUsers = new Array<string>();
    this.listOfUsersTarget = new Array<string>();
  }

  ngOnInit() {
    this.filteredMyFolders = this.myfolderCtrl.valueChanges
      .pipe(startWith(''), map(val => this.filterMyfolders(val, this.listOfUsers)));

    this.filteredMyFoldersTarget = this.myfolderCtrlTarget.valueChanges
      .pipe(startWith(''), map(val => this.filterMyfoldersTarg(val, this.listOfUsersTarget)));
  }
  filterMyfolders(userName: string, list: String[]): String[] {
    return list.filter(myfolderSrc =>
      myfolderSrc.toLowerCase().indexOf(userName.toLowerCase()) === 0);
  }

  filterMyfoldersTarg(userName: string, list: String[]): String[] {
    return list.filter(myfolderTarg =>
      myfolderTarg.toLowerCase().indexOf(userName.toLowerCase()) === 0);
  }

  getNodeChildDetails(rowItem) {
    if (rowItem.reports) {
      return {
        group: true,
        children: rowItem.reports,
        key: rowItem.group
      };
    } else {
      return null;
    }
  }
  showSourceTree() {
    this.gridOptionsSrc.api.showLoadingOverlay();
    this.service.getContent(this.selectedValueSrc, false).subscribe((data: any) => {
      this.folderDataSrcMain = this.parseFolders(data, false);
      this.getRowDataSrc(this.folderDataSrcMain);
      this.getEnvironmentSpecificUsersSrc();
    });
  }

  showTargetTree() {
    this.gridOptionsTarg.api.showLoadingOverlay();
    this.service.getContent(this.selectedValueTarg, true).subscribe((data: any) => {
      this.folderDataTargMain = this.parseFolders(data, true);
      this.getRowDataTarg(this.folderDataTargMain);
      this.getEnvironmentSpecificUsersTarget();
    });
  }

  extractMyFolders(folders, skipReports) {
    const nodes = [];
    if (!!folders && folders.length > 0) {
      folders.forEach(folder => {
        if (folder.name.indexOf('My Folders') > -1) {
          const userName = folder.name.slice(folder.name.indexOf('(') + 1, folder.name.indexOf(')'));
          this.allUsers.push(userName);
          const folderDatat: Folderdata = new Folderdata(folder.storeId, folder.name, this.parseFolders(folder.folders, skipReports),
            folder.searchPath, true, true, userName);
          if (!skipReports) {
            // Gather reports
            folder.reports.forEach(report => {
              const reportDatat: Reportdata = new Reportdata(report.storeId, report.name, true, report.searchPath);
              folderDatat.reports.push(reportDatat);
            });
          }
          nodes.push(folderDatat);
        }
      });
    }
    return nodes;
  }

  parseFolders(folders, skipReports) {
    const nodes = [];

    if (!!folders && folders.length > 0) {
      // Gather folders
      folders.forEach(folder => {

        const folderDatat: Folderdata = new Folderdata(folder.storeId, folder.name, this.parseFolders(folder.folders, skipReports),
          folder.searchPath, true, true);
        if (!skipReports) {
          // Gather reports
          folder.reports.forEach(report => {
            const reportDatat: Reportdata = new Reportdata(report.storeId, report.name, true, report.searchPath);
            folderDatat.reports.push(reportDatat);
          });
        }
        nodes.push(folderDatat);
      });
    }
    return nodes;
  }

  onGridReady(params) {
    params.api.sizeColumnsToFit();
  }

  onRowSelectedSrc(event: any) {
    if (this.gridOptionsSrc.api.getSelectedRows() != null && this.gridOptionsSrc.api.getSelectedRows().length > 0
      && this.gridOptionsTarg.api.getSelectedRows() != null && this.gridOptionsTarg.api.getSelectedRows().length > 0) {
      this.iscopyEnabled = true;
    }
  }
  getEnvironmentSpecificUsersSrc() {
    // this.gridOptionsSrc.api.showLoadingOverlay();
    this.service.getAllUser(this.selectedValueSrc).subscribe((data: any[]) => {
      this.listOfUsers = data;
    });
  }

  getEnvironmentSpecificUsersTarget() {
    // this.gridOptionsTarg.api.showLoadingOverlay();
    this.service.getAllUser(this.selectedValueTarg).subscribe((data: any[]) => {
      this.listOfUsersTarget = data;
    });
  }
  updateGridDataSrc(event) {
    this.gridOptionsSrc.api.showLoadingOverlay();
    this.service.getUserFolders(this.selectedValueSrc, false, event.option.value).subscribe((data: any) => {
      this.folderDataSrc = this.parseFolders(data[0].folders, false);
      this.getRowDataSrc(this.folderDataSrc);
      let myfolderSrc: Folderdata;
      this.folderDataSrc.forEach(folder => {
        if (folder.title.includes(event.option.value)) {
          myfolderSrc = folder;
        }
      });
      this.rowDataSrc = this.addSelectedMyFolderToGridData(myfolderSrc, this.folderDataSrcMain);
      this.gridOptionsSrc.api.refreshCells();
    });
  }

  updateGridDataTarget(event) {
    this.gridOptionsTarg.api.showLoadingOverlay();
    this.service.getUserFolders(this.selectedValueTarg, true, event.option.value).subscribe((data: any) => {
      this.folderDataTarg = this.parseFolders(data[0].folders, true);
      this.getRowDataTarg(this.folderDataTarg);
      let myfolderTarg: Folderdata;
      this.folderDataTarg.forEach(folder => {
        if (folder.title.includes(event.option.value)) {
          myfolderTarg = folder;
        }
      });
      this.rowDataTarg = this.addSelectedMyFolderToGridData(myfolderTarg, this.folderDataTargMain);
      this.gridOptionsTarg.api.refreshCells();
    });
  }

  onRowSelectedTarg(event: any) {
    if (this.gridOptionsSrc.api.getSelectedRows() != null && this.gridOptionsSrc.api.getSelectedRows().length > 0
      && this.gridOptionsTarg.api.getSelectedRows() != null && this.gridOptionsTarg.api.getSelectedRows().length > 0) {
      this.iscopyEnabled = true;
    }
  }
  copy() {
    this.SrcRowSelected = this.gridOptionsSrc.api.getSelectedRows();
    this.TargFolderSelected = this.gridOptionsTarg.api.getSelectedRows();
    this.SrcRowSelected.forEach(selectedRow => {
      const reportSelected: Reportdata = selectedRow;
      const folderSelected: Folderdata = this.TargFolderSelected[0];
      const selectedReport: SelectedReport = new SelectedReport(this.selectedValueSrc, this.selectedValueTarg,
        reportSelected.searchPath, folderSelected.searchPath);
      this.selectedReports.push(selectedReport);
    });
    this.gridOptionsSrc.api.deselectAll();
    this.gridOptionsTarg.api.deselectAll();
    this.iscopyEnabled = false;
  }

  open() {
    const header = 'Deployment Request';
    const dialogRef = this.dialog.open(ActionDialogComponent, {
      width: '900px',
      autoFocus: false,
      data: {
        action: 'request',
        header: header,
        params: this.selectedReports
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (!result) {
        this.clearSelection();
      }
    });
  }

  clearSelection() {
    this.selectedReports = [];
    this.SrcRowSelected = [];
    if (this.gridOptionsSrc.api != null) {
      this.gridOptionsSrc.api.deselectAll();
    }
    this.gridOptionsTarg.api.deselectAll();
  }

  getRowDataSrc(data) {
    this.rowDataSrc = data;
  }

  addSelectedMyFolderToGridData(data: Folderdata, rowData: Folderdata[]) {
    const folderData: Folderdata = {
      collapsed: false,
      folder: true,
      reports: data.reports,
      title: data.title,
      id: '-1',
      searchPath: null,
      user: null
    };
    // clone current row data to clear existing data
    rowData = rowData.map(x => Object.assign({}, x));

    if (rowData[rowData.length - 1].id === '-1') {
      rowData[rowData.length - 1] = folderData;
    } else {
      rowData.push(folderData);
    }
    return rowData;
  }

  getColumnDefSrc() {
    return [
      {
        headerName: '', field: 'title', cellRenderer: 'agGroupCellRenderer',
      }
    ];
  }
  getColumnDefTarg() {
    return [
      { headerName: '', field: 'title', cellRenderer: 'agGroupCellRenderer', cellRendererParams: { checkbox: true, suppressCount: true } }
    ];
  }

  getRowDataTarg(data) {
    this.rowDataTarg = data;
  }
  getReportsCount(params) {
    return params.data.requestDetails.length;
  }
}



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/bi-admin/newrequest/newrequest.component.ts